var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5.83366 7.5H1.66699V5.83333H5.83366V7.5ZM5.83366 10H1.66699V11.6667H5.83366V10ZM17.1587 15.8333L13.967 12.6417C13.3003 13.075 12.517 13.3333 11.667 13.3333C9.36699 13.3333 7.50033 11.4667 7.50033 9.16667C7.50033 6.86667 9.36699 5 11.667 5C13.967 5 15.8337 6.86667 15.8337 9.16667C15.8337 10.0167 15.5753 10.8 15.142 11.4583L18.3337 14.6583L17.1587 15.8333ZM14.167 9.16667C14.167 7.79167 13.042 6.66667 11.667 6.66667C10.292 6.66667 9.16699 7.79167 9.16699 9.16667C9.16699 10.5417 10.292 11.6667 11.667 11.6667C13.042 11.6667 14.167 10.5417 14.167 9.16667ZM1.66699 15.8333H10.0003V14.1667H1.66699V15.8333Z",
    fill: "#F2F4F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilter);
export default __webpack_public_path__ + "static/media/search_filter.9c2d95203b94717d2fbe3ab7ece22a37.svg";
export { ForwardRef as ReactComponent };